const SET_REPEATED_FROM = 'directOrderRecurring/SET_REPEATED_FROM';

export default {
  SET_REPEATED_FROM,
};
